import { Col, Row, Toast } from "react-bootstrap";

function MessageErreurToast({
    afficherMessageErreur,
    messageErreur,
    setAfficherMessageErreur
}) {

    const fermeMessageErreur = () => {
        setAfficherMessageErreur(false);
    }

    return (
        <Row>
            <Col className="align-right">
                <Toast show={afficherMessageErreur} onClose={fermeMessageErreur}>
                    <Toast.Header>
                        <img src="holder.js/20x20?text=%20" className="rounded mr-2" alt="" />
                        <strong className="mr-auto">Info</strong>
                    </Toast.Header>
                    <Toast.Body>Désolé vous avez déjà participé !</Toast.Body>
                </Toast>
            </Col>
        </Row>
    );
}

export default MessageErreurToast;
